import { DisplayPackType } from 'c-sdk';

/**
 * Slots and share of voice are two views of one number on the screen, pack and new-screen forms:
 * SOV (%) = 100 / slots. Typing in either field fills the other in, to 10 decimal places.
 * These keep the forms' existing arithmetic exactly (including what an empty field gives).
 */
export const sovFromSlots = (slots: string): string =>
    Number(slots !== '' ? 100 / Number(slots) : '').toFixed(10);

export const slotsFromSov = (sov: string): string =>
    Number(sov !== '' ? 100 / Number(sov) : '').toFixed(10);

/** The SOV shown when a pack is opened for editing; the API only stores slots. */
export const initialSovForSlots = (slots: number | null | undefined): string | null =>
    slots !== null ? Number(100 / Number(slots)).toFixed(10) : null;

/**
 * The pack form's type select works in `'pack'`/`'site'` (what the API's PackType cast reads and
 * returns), but the database stores 0/1, so a raw 0 or 1 is mapped onto the select's values.
 * Anything else is left as it is.
 */
export const normalisePackType = (value: unknown): DisplayPackType | undefined => {
    if (value === 0) return DisplayPackType.Pack;
    if (value === 1) return DisplayPackType.Site;
    return undefined;
};
